import React from 'react';
import { MdWhatsapp } from 'react-icons/md';

import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

const ContactCard: React.FC<{ className?: string }> = ({ className }) => (
  <Card className={className}>
    <CardHeader>
      <CardTitle>Entre em Contato</CardTitle>
      <CardDescription></CardDescription>
    </CardHeader>
    <CardContent className="flex flex-col items-center justify-center gap-4">
      <a
        href="https://api.whatsapp.com/send?phone=55555399579967"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button className="gap-2 bg-green-400 hover:bg-green-400/90">
          <MdWhatsapp size={24} />
          WhatsApp SAP
        </Button>
      </a>

      <div className="hidden flex flex-col items-center justify-center gap-0">
        <h3 className="text-lg font-semibold text-gray-500 dark:text-gray-400">
          Token
        </h3>
        <p className="text-base text-gray-500 dark:text-gray-400">algo aqui</p>
      </div>
    </CardContent>
  </Card>
);

export default ContactCard;
